import { Col, Form, Row } from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { CollapseBlock, ImageCard } from '../../../../../common/index.jsx';
import { StyledLabel } from '../../../../../common/form/FormElements.jsx';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect.jsx';
import FormHiddenField from '../../../../../antd/form/FormHiddenField/FormHiddenField.jsx';
import { required } from '../../../../../antd/form/FormValidation.js';

export default function ImageAndCategoriesBlock({
  onImageCardOpen,
  categories,
  form,
}) {
  const { t } = useTranslation();
  const imageName = Form.useWatch('image_name', form);

  return (
    <CollapseBlock
      collapsible
      collapse
      title={t('Kategórie a prezentačný obrázok')}
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <FormHiddenField name={`image_name`} />
          <StyledLabel>{t('Prezentačný obrázok')}</StyledLabel>
          <ImageCard
            image={imageName || undefined}
            tooltip={t('Zvoliť prezentačný obrázok')}
            onClick={() => onImageCardOpen()}
            icon="fas fa-edit"
          />
        </Col>
        <Col span={12}>
          <FormSelect
            label={t('Kategórie')}
            name={'categories'}
            options={categories}
            mode="multiple"
            rules={[required(t)]}
            fieldNames={{
              label: 'name',
              value: 'id',
            }}
          />
        </Col>
      </Row>
    </CollapseBlock>
  );
}

ImageAndCategoriesBlock.propTypes = {
  onImageCardOpen: PropTypes.func,
  categories: PropTypes.array,
};
